const cmsFallbackReferalSchema = {
  btn_label: 'Share referral link',
  btn_title: 'SHARE_REFERRAL_BUTTON',
  cardBody: 'Get {REFERRAL_IP} IPs for every friend you invite',
  cardSubBody: 'Get {INITIAL_REFERRAL_INSTAPOINT} InstaPoints for every person you refer',
  cardTitle: 'Earn by inviting friends',
  labelAndLinks: {
    referralCardSubHeading:
      'Refer people to join us and get {INITIAL_REFERRAL_INSTAPOINT} InstaPoints ',
    seeDetailsBtn: 'See details',
    shareData: {
      shareMessage: `Hey guys, I use Instarem.com for cost-effective overseas money transfers. 
          Inviting you too. Get signup and referral bonus points on your first transfer!`,
      shareSubject: 'Invitation Link',
      shareTitle: 'Invitation Link'
    },
    subHeading: 'worth {REFERRAL_POINT_VALUE}',
    subHeading1: ' when they make their first transfer ',
    subHeadingAmaze: 'or transact above 10 SGD with amaze card.',
    shareText: 'Copy or share your referral link below with friends'
  },
  supportingCountryCode: 'DEFAULT',
  title: 'INVITE_EARN_DEFAULT'
};

export default cmsFallbackReferalSchema;
